<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import StartMenu from "@/components/StartMenu.vue";

const router = useRouter();
const auth = useAuthStore();

const startOpen = ref(false);

const toggleStart = () => {
  startOpen.value = !startOpen.value;
};
const closeStart = () => {
  startOpen.value = false;
};
const go = (path) => {
  router.push(path);
  closeStart();
};
const logout = () => {
  auth.logout();
  router.replace("/");
};
</script>

<template>
  <div class="desktop" @click.self="closeStart">
    <!-- 가운데 작업 영역 -->
    <main class="workspace">
      <RouterView />
    </main>

    <!-- 시작 메뉴 -->
    <StartMenu
      :open="startOpen"
      @close="closeStart"
      @navigate="go"
      @logout="logout"
    />

    <!-- 작업 표시줄 -->
    <footer class="taskbar">
      <button class="start-btn" @click.stop="toggleStart">⊞ 시작</button>

      <div class="taskbar-spacer"></div>

      <div class="tray">
        <span class="user">{{ auth.user?.name ?? "" }}</span>
        <span class="clock">{{ new Date().toLocaleTimeString() }}</span>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.desktop {
  /* use runtime --vh to avoid browser chrome (address bar) changing layout */
  height: calc(var(--vh, 1vh) * 100);
  background: linear-gradient(120deg, #0b2a4a, #0a1430 60%);
  color: #eaf2ff;
  overflow: hidden;
}
.workspace {
  padding: 18px;
  /* keep space for the fixed taskbar + any device safe-area inset */
  padding-bottom: calc(48px + env(safe-area-inset-bottom, 0px) + 12px);
}
.taskbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 10px;
  /* add safe-area padding so the taskbar stays above device UI (notch, nav bars) */
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: rgba(20, 28, 45, 0.85);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 20;
}
.start-btn {
  height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.08);
  color: #eaf2ff;
  cursor: pointer;
}
.taskbar-spacer {
  flex: 1;
}
.tray {
  display: flex;
  gap: 10px;
  opacity: 0.9;
  font-size: 12px;
}
.clock {
  font-variant-numeric: tabular-nums;
  margin-left: 12px;
}

/* ===== Mobile Responsive Styles ===== */

@media (max-width: 768px) {
  .workspace {
    padding: 12px;
    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px) + 8px);
  }

  .taskbar {
    height: 56px;
    gap: 8px;
    padding: 0 8px;
  }

  .start-btn {
    height: 40px;
    padding: 0 8px;
    font-size: 14px;
    min-width: 40px;
  }

  .tray {
    gap: 6px;
    font-size: 11px;
  }

  .clock {
    margin-left: 6px;
  }
}

@media (max-width: 480px) {
  .workspace {
    padding: 8px;
    padding-bottom: calc(54px + env(safe-area-inset-bottom, 0px) + 6px);
  }

  .taskbar {
    height: 54px;
    gap: 6px;
    padding: 0 6px;
  }

  .start-btn {
    height: 38px;
    padding: 0 6px;
    font-size: 12px;
    min-width: 38px;
    border-radius: 8px;
  }

  .tray {
    display: none;
  }
}
</style>
